const Allchapterallocs = ({date_sent,month_on_focus,amount_alloted,chapter_name,total_month_income,username}) => {
    const monthColors={
        "January": "#075E54",
        "December": "#0251EB",
        "February": "#ff4500",
        "March": "#FF3700B3",
        "April": "#6B014D",
        "May": "#1a1a1a",
        "June": "#29335c",
        "July": "#34B7F1",
        "August": "#25D366",
        "September": "#011F36",
        "October": "#696969",
        "November": "#000000"
    };
    return (  
        <div className="allchapterallocs flex-column2" key={date_sent} style={{backgroundColor:monthColors[month_on_focus]}}>
            <h3 style={{border:"2px solid white",padding:"5px"}}>
                Chapter: {chapter_name}
            </h3>
            <div className="flex-row2" style={{gap:"5px"}}>
                <h4>{`${month_on_focus} (Income):`}</h4>
                <p>
                    {parseFloat(total_month_income).toLocaleString('en-US',{style:'currency',currency:'GHS'})}
                </p>
            </div>

            <div className="flex-row2" style={{gap:"5px"}}>
                <h4>Amount Allocated:</h4>
                <p>
                    {parseFloat(amount_alloted).toLocaleString('en-US',{style:'currency',currency:'GHS'})}
                </p>
            </div>

                <div style={{width:"100%",border:"1px solid white"}}></div>

                <h3>Remitted by: {username}</h3>
                <h3>Remitted on: {date_sent}</h3>
        </div>
    );
}
export default Allchapterallocs;